import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import moment from 'moment';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';

import VueTour from 'vue-tour'

import whitemark from '@/assets/whitemarker/whitemark.json';

require('vue-tour/dist/vue-tour.css')
console.log(process.env.VUE_APP_WHITE_MARK_ID);
Vue.prototype.$wm = whitemark[process.env.VUE_APP_WHITE_MARK_ID || 'pm']
document.title = Vue.prototype.$wm.title
Vue.prototype.$env = process.env
Vue.use(VueTour)

import VueGtag from "vue-gtag";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import axios from 'axios';

import Highcharts from "highcharts";
import Stock from "highcharts/modules/stock";
import HighchartsVue from "highcharts-vue";

Stock(Highcharts);
Vue.use(HighchartsVue);

axios.defaults.showLoader = true;


Sentry.init({
	Vue,
	dsn: "https://7b2edb4d4e314edf9538efa54c61c589@o309368.ingest.sentry.io/6079636",
	integrations: [
	  new Integrations.BrowserTracing({
		routingInstrumentation: Sentry.vueRouterInstrumentation(router),
		tracingOrigins: ["localhost", "my.previmeteo.com", /^\//],
	  }),
	],
	tracesSampleRate: 1.0,
  });


Vue.use(VueGtag, {
  config: { id: "UA-221411-17" },
  pageTrackerUseFullPath: true
});

moment.locale('fr');

Vue.config.productionTip = false;

const checkLimit = key => {
	if (!store.state.user) return false;
	let limit = store.state.user.limits.find(map => map.key == key);

	if (limit) {
		return limit.value;
	} else {
		return false;
	}
};

Vue.prototype.$checkLimit = checkLimit;

Vue.use(VueTelInputVuetify, {
	vuetify,
});

new Vue({
	router,
	store,
	vuetify,
	i18n,
	created() {
		axios.interceptors.request.use(
			config => {
				if (config.showLoader) {
					store.dispatch('loader/pending');
				}
				return config;
			},
			error => {
				if (error.config.showLoader) {
					store.dispatch('loader/done');
				}
				return Promise.reject(error);
			}
		);
		axios.interceptors.response.use(
			response => {
				if (response.config.showLoader) {
					store.dispatch('loader/done');
				}
	
				return response;
			},
			error => {
				let response = error.response;
	
				if (response.config.showLoader) {
					store.dispatch('loader/done');
				}
	
				return Promise.reject(error);
			}
		)
	},
	render: h => h(App),
}).$mount('#app');
